<template>
  <div ref="dropdown" class="language-dropdown">
    <button
      class="language-dropdown__btn flex ttc btn btn--text items-center bg-transparent"
      style="margin-left: auto;"
      ref="dropdownButton"
      @click="handleLanguageDropdownClick"
      @keydown.esc="closeLanguageDropdown"
    >
      <span class="language-dropdown__text" v-if="!languageChosen">{{$t('selectLanguage')}}</span>
      <span class="language-dropdown__text" v-else>{{selectedLanguage}}</span>
      <!-- <span class="fw3 moon-gray mh1">|</span> -->
      <span class="language-dropdown__separator">&nbsp;</span>
      <!-- icon down triangle -->
      <div class="icon language-dropdown__text">▼</div>
    </button>

    <div @blur="onBlur" ref="dropdownList" tabindex="0">
      <ul
        :class="{'w-100': !languageChosen}"
        class="language-dropdown__list"
        v-if="languageDropdownVisible"
      >
        <li v-if="!languageChosen">
          <p class="text ph5">› {{$t('selectLanguage')}}</p>
        </li>

        <li v-for="language in languages" :key="language.language">
          <a
            @click="handleClose(language.language)"
            :id="language.title"
            class="link"
            :class="{'language-selected': (getLanguage() === language.language)}"
            href="#"
          >{{language.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getLanguage, getPathNameFromRouteName, findElementInChildren, setCookie, getCookie } from '@/utils/common';
export default {
  data() {
    return {
      languageDropdownVisible: false,
      languages: [
        { flag: 'us', language: 'en-us', title: 'English' },
        { flag: 'fr', language: 'fr', title: 'French' },
        { flag: 'it', language: 'it', title: 'Italian' },
        { flag: 'ja', language: 'ja', title: 'Japanese' },
        { flag: 'pt', language: 'pt', title: 'Portuguese' },
        { flag: 'es', language: 'es', title: 'Spanish' },
        { flag: 'ms', language: 'ms', title: 'Malay' }
      ],
      languageChosen: getCookie('lng_chosen')
    };
  },
  computed: {
    selectedLanguage() {
      let selectedLanguageObject = this.languages.find(language => {
        return getLanguage() === language.language;
      });
      return selectedLanguageObject.title;
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    getLanguage: getLanguage,
    handleClose(language) {
      let originalLocation = window.location.href;
      /* eslint-disable no-useless-escape */
      let regex = new RegExp(`\/${getLanguage()}`, 'g');
      this.changeLanguage(language).then(() => {
        setCookie('lng_chosen', true);
        let redirectPathName = `${getPathNameFromRouteName(this.$route.name, this.$router)}${window.location.search}`;
        const queryHash = originalLocation.match(new RegExp('query' + '=([^&]*)'));
        if (queryHash) {
          redirectPathName = `${redirectPathName}#query=${decodeURIComponent(queryHash[1])}`;
        }
        if (redirectPathName) {
          window.location.href = `/${language}/${redirectPathName.replace(/ /g, '-')}`;
        } else {
          window.location.href = originalLocation.replace(regex, `/${language}`);
        }
      });
    },
    toggleOpenState() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleLanguageDropdownClick(e) {
      this.toggleOpenState();
      if (this.languageDropdownVisible) {
        this.$refs.dropdownList.focus();
      }
    },
    closeLanguageDropdown() {
      this.languageDropdownVisible = false;
    },
    onBlur(e) {
      const children = Array.from(this.$refs.dropdownList.children);
      const target = e.relatedTarget;
      const found = children.find(child => findElementInChildren(child, target));
      if (!found && target !== this.$refs.dropdownButton) {
        this.languageDropdownVisible = false;
        this.$refs.dropdownButton.blur();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.language-dropdown {
  position: relative;
  z-index: 2;
  margin-right: 0.5rem;
}
.language-dropdown__list {
  z-index: 2;
  position: absolute;
  text-align: left;
  background-color: #ffffff;
  text-decoration: none;
  border: 1px solid #6b90da;
  overflow: hidden;
  padding: 4px;
  margin: 0.3rem 0 0 0;
  border-radius: 5px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  animation: bounce 0.6s ease-out;
  right: 0;

  .text {
    margin: 0;
    padding: 0.2rem;
    font-weight: 600;
    color: #000;
    font-size: 0.9rem;
  }
  .link {
    padding: 0.2rem;
    color: #0000cc;
    font-weight: 300;
    font-family: arial;
    font-size: 0.85rem;
  }
  .link:hover {
    background-color: #3366cc;
    color: #fff;
  }
  .text,
  .link {
    display: block;
  }
}
.language-dropdown__text {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
}
.language-selected {
  font-weight: 600 !important;
}
.language-dropdown__btn:focus {
  outline: none;
  border: none;
}
.language-dropdown__btn:hover {
  opacity: 0.8;
  cursor: pointer;
}
.language-dropdown__separator {
  border-left: 1px solid rgb(187, 187, 187);
  margin-left: 6px;
}
</style>
